import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
// @ts-ignore
import { makeSelectTimesheetValue } from 'services/timesheets/selectors';

interface OwnProps {
    timesheetId: number;
}

interface ConnectedProps {
    submissionReference?: number | null;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetSubmissionReference extends React.PureComponent<Props> {
    render(): number | null {
        const { submissionReference } = this.props;
        if (!submissionReference) {
            return null;
        }
        return submissionReference;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    submissionReference: makeSelectTimesheetValue('payrollExportId')
});

export default connect(mapStateToProps)(TimesheetSubmissionReference);
